import { AppAbilityType } from '../../../components/ability/ability';

const VIEW_NAVIGATION = {
    PRICE_RESPONSE_TRIGGERS: '/price-response/triggers',
    PRICE_RESPONSE_SCENARIOS: '/price-response/scenarios',
};

export const priceResponseViewInterface = (userAbility: AppAbilityType) =>
    userAbility.can('view-route', '/price-response/triggers') && userAbility.can('view-route', '/price-response/scenarios')
        ? [
              {
                  title: 'Triggers',
                  value: VIEW_NAVIGATION.PRICE_RESPONSE_TRIGGERS,
                  tooltip: 'Triggers',
                  isVisible: true,
              },
              {
                  title: 'Scenarios',
                  value: VIEW_NAVIGATION.PRICE_RESPONSE_SCENARIOS,
                  tooltip: 'Scenarios',
                  isVisible: true,
              },
          ]
        : [];
